const isPoint = (geometry) => (geometry === null || geometry === void 0 ? void 0 : geometry.type) === 'Point';
const isPolygonOrMultiPolygon = (geometry) => (geometry === null || geometry === void 0 ? void 0 : geometry.type) === 'Polygon'
    || (geometry === null || geometry === void 0 ? void 0 : geometry.type) === 'MultiPolygon';
const isCoordinates = (array) => array.length === 2
    && typeof array[0] === 'number'
    && typeof array[1] === 'number';
const createImageElement = (src) => {
    if (!src)
        return;
    const element = document.createElement('img');
    element.src = src;
    element.style.objectFit = 'cover';
    element.style.height = '30px';
    element.style.width = '30px';
    element.style.borderRadius = '80px';
    element.style.background = 'white';
    element.style.display = 'block';
    element.id = 'user-photo';
    element.style.border = '4px solid white';
    return element;
};
const createBlueCircleElement = () => {
    const element = document.createElement('div');
    element.className = 'blue-circle';
    element.style.width = '25px';
    element.style.height = '25px';
    element.style.maxWidth = '25px';
    element.style.position = 'absolute';
    element.style.zIndex = '2';
    element.style.minWidth = 'unset';
    element.style.borderRadius = '50%';
    element.style.border = '4px solid white';
    element.style.backgroundColor = '#3979FA';
    return element;
};
const getPointMapSourceCoordinates = (source) => {
    var _a, _b, _c, _d, _e;
    if (!isPoint((_a = source === null || source === void 0 ? void 0 : source.data[0]) === null || _a === void 0 ? void 0 : _a.geometry))
        return null;
    return [
        (_c = (_b = source === null || source === void 0 ? void 0 : source.data[0]) === null || _b === void 0 ? void 0 : _b.geometry.coordinates[0]) !== null && _c !== void 0 ? _c : 0,
        (_e = (_d = source === null || source === void 0 ? void 0 : source.data[0]) === null || _d === void 0 ? void 0 : _d.geometry.coordinates[1]) !== null && _e !== void 0 ? _e : 0,
    ];
};
const getPointProperties = (source) => { var _a, _b; return (_b = (_a = source === null || source === void 0 ? void 0 : source.data[0]) === null || _a === void 0 ? void 0 : _a.properties) !== null && _b !== void 0 ? _b : null; };
const roundedLatLng = (lng, lat, GROUPING_THRESHOLD = 0.0001) => {
    const roundedLat = Math.round((lat !== null && lat !== void 0 ? lat : 0) / GROUPING_THRESHOLD);
    const roundedLng = Math.round((lng !== null && lng !== void 0 ? lng : 0) / GROUPING_THRESHOLD);
    return [roundedLng, roundedLat];
};
const maybeGetSourceGroupForProcessing = (source, allSourcesByLatLng, groupingThreshold) => {
    var _a, _b, _c, _d;
    const group = [source];
    const data = source.data[0];
    if (!isPoint(data === null || data === void 0 ? void 0 : data.geometry))
        return group;
    const [lat, lng] = (_b = (_a = data === null || data === void 0 ? void 0 : data.geometry) === null || _a === void 0 ? void 0 : _a.coordinates) !== null && _b !== void 0 ? _b : [0, 0];
    const [roundedLat, roundedLng] = roundedLatLng(lat, lng, groupingThreshold);
    group.push(...((_d = (_c = allSourcesByLatLng[roundedLat]) === null || _c === void 0 ? void 0 : _c[roundedLng]) !== null && _d !== void 0 ? _d : []));
    return group;
};
const getPolygonOrMultiPolygonCentroid = (geometry) => {
    const polygons = geometry.type === 'MultiPolygon' ? geometry.coordinates : [geometry.coordinates];
    let totalArea = 0;
    let totalCx = 0;
    let totalCy = 0;
    polygons.forEach((polygonCoordinates) => {
        let area = 0;
        let cx = 0;
        let cy = 0;
        const coordinates = polygonCoordinates[0] || [];
        coordinates.forEach((coord, index) => {
            if (index === (coordinates.length - 1))
                return;
            const [x1 = 0, y1 = 0] = coord;
            const [x2 = 0, y2 = 0] = coordinates[index + 1] || [];
            const f = x1 * y2 - x2 * y1;
            area += f;
            cx += (x1 + x2) * f;
            cy += (y1 + y2) * f;
        });
        area = Math.abs(area / 2);
        cx /= (6 * area);
        cy /= (6 * area);
        totalArea += area;
        totalCx += cx * area;
        totalCy += cy * area;
    });
    const finalCx = totalCx / totalArea;
    const finalCy = totalCy / totalArea;
    return { lat: -finalCy, lng: -finalCx };
};
const getAveragePoint = (points) => {
    const sumLng = points.reduce((acc, { lng }) => acc + (lng !== null && lng !== void 0 ? lng : 0), 0);
    const sumLat = points.reduce((acc, { lat }) => acc + (lat !== null && lat !== void 0 ? lat : 0), 0);
    return { lng: sumLng / points.length, lat: sumLat / points.length };
};

export { createBlueCircleElement, createImageElement, getAveragePoint, getPointMapSourceCoordinates, getPointProperties, getPolygonOrMultiPolygonCentroid, isCoordinates, isPoint, isPolygonOrMultiPolygon, maybeGetSourceGroupForProcessing, roundedLatLng };
